import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';

import Modal from 'four-nets/ui-v2/modal/modal';
import { VendorInformationFragment } from 'four-nets/photoblog/user-blog/author-side/author-side-components/vendor-information/vendor-information.graphql';
import AlbumImagesReorder from 'four-nets/photoblog/posts/album/edit/images-reorder/images-reorder';
import AlbumImagesEdit from 'four-nets/photoblog/posts/album/edit/images-edit/images-edit';
import AddImages from 'four-nets/photoblog/posts/album/edit/add-images/add-images';

import defaultStyles from './update-vendor-album.scss';
import RouteWithSearch from 'lib/react-router/route-with-search';

interface Props {
    styles: typeof defaultStyles;
    open?: boolean;
    onClose: () => void;
    vendor: VendorInformationFragment;
}

const UpdateVendorAlbum: React.FC<Props> = props => {
    const { styles, open, onClose, vendor } = props;

    if (!vendor) {
        return null;
    }

    return (
        <Modal title={<FormattedMessage id='EDIT_ALBUM' />} open={Boolean(open)} onClose={onClose}>
            <div className={styles.padding}>
                <AddImages {...(vendor.album as any)} />
                <div className={styles.subheading}>
                    <FormattedMessage id='EDIT_ALBUM_PHOTOS' />
                </div>
                <RouteWithSearch
                    render={props => (
                        <AlbumImagesEdit
                            {...props}
                            excludeHeader={true}
                            onClose={onClose}
                            match={{ params: { username: vendor.user.username, slug: vendor.album.slug } } as any}
                        />
                    )}
                />
            </div>
        </Modal>
    );
};

export default Styled(defaultStyles)(UpdateVendorAlbum);
